/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';

import COLORS from '../styles/Colors';

interface Props {
  src: string;
  size: number;
  backgroundColor: string;
  placeholderText: string;
  noBorder?: boolean;
  hasDropshadow?: boolean;
  altText: string;
}

const SquareImageIcon = (props: Props) => {
  const { src, size, backgroundColor, placeholderText, noBorder, hasDropshadow, altText } = props;
  const borderColor = noBorder ? 'transparent' : COLORS.gsMiddleDT;
  const className = hasDropshadow ? '_dropshadow' : null;
  return (
    <div className="cmp-squareimageicon">
      {
        src ? <img alt={altText} className={className} style={{ borderRadius: '4px', borderColor }} src={src} width={size} height={size} /> : (
          <div className={classnames('img', className)} style={{ height: size, width: size, backgroundColor, borderColor }}>
            <span>{placeholderText}</span>
          </div>
        )
      }
    </div>
  );
};

export default SquareImageIcon;
